import type { ReactNode } from 'react';
import './StatGroup.css';

/**
 * StatGroup — **요약 묶음** (디자인 정본 D9-3 · 2026-09-06 신설).
 *
 * ★★ D9-2 `StatTile` 은 **한 줄**만 정했다. 칸이 다섯을 넘고 갈래가 뚜렷하면 어느 것이 어느
 *    갈래인지 안 보인다 — 근태 현황의 요약이 **근무 상태 · 시간과 기록 이상 · 초과 근무**
 *    셋으로 갈리는 것이 그 이유다(사용자 지시).
 *
 * ★ **상자를 주지 않는다.** 타일이 이미 상자다 — 상자 안에 상자를 넣으면 테두리가 두 겹이 되고
 *   위계가 납작해진다. 묶음의 폭은 **이름 뒤로 끝까지 가는 선**이 그린다.
 * ★ **칸이 넷 이하면 쓰지 않는다** — D9-2 한 줄로 충분하고, 묶음 이름이 오히려 잡음이 된다.
 * ⚠ 안에 두는 `StatTiles` 에는 **이름을 또 붙이지 않는다** — 묶음이 이미 그 절의 이름이라,
 *   둘 다 붙이면 «같은 이름의 지역»이 둘이 되어 읽어 주는 프로그램이 두 번 말한다.
 */
export function StatGroups({ children, inline = false, className }: {
  children: ReactNode;
  /**
   * **알약 줄** — 묶음 이름을 왼쪽에 세우고 칸을 옆으로 눕힌다 (2026-09-06 · 사용자 결정).
   * ★ 칸이 아홉을 넘고 **낮아야 할 때** 쓴다(근태 현황은 달력이 주인공이라 요약이 낮아야 한다).
   *   같은 자리를 타일로 그리면 354px, 알약 줄로 그리면 119px 이다(실측).
   * ★ 안의 칸은 `size="chip"` 이라야 한다 — 알약은 **이름이 먼저** 읽히는 물건이다.
   */
  inline?: boolean;
  className?: string;
}) {
  return (
    <div className={['wc-statg', inline ? 'wc-statg--inline' : '', className ?? ''].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

export function StatGroup({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <section className="wc-statg__g" aria-label={typeof title === 'string' ? title : undefined}>
      <p className="wc-statg__t">{title}</p>
      {children}
    </section>
  );
}
